import React, { useCallback } from "react";
import { InfoContainer } from "src/screens/dashboard/customers/details/detail/info-container/InfoContainer";
import { ICustomerSetting } from "src/stores/CustomerDetailPageStore";
import { dateFormat } from "src/utils/Date";
import { Link } from "react-router-dom";

interface CustomerFileUsageProps {
    customerFileUsage?: ICustomerSetting[];
    filesWithErrorsCount?: number;
}

interface FileUsageInfoType {
    fileCount?: string | null;
    usedKb?: string | null;
    udpated?: string | null;
}

enum FILE_USAGE {
    FILE_COUNT = "FILES.FILE_COUNT",
    USED_KB = "FILES.USED_KB"
}

const CustomerFileUsage = (props: CustomerFileUsageProps) => {
    const getFormattedFileSize = (fileSize: string): string => {
        let fileSizeInt: number = 0;
        let fileSizeUnit: string = "KB";

        fileSizeInt = parseInt(fileSize);

        if (fileSizeInt / 1000000 >= 1) {
            fileSizeInt /= 1000000;
            fileSizeUnit = "GB";
        } else if (fileSizeInt / 1000 >= 1) {
            fileSizeInt /= 1000;
            fileSizeUnit = "MB";
        }

        return `${fileSizeInt} ${fileSizeUnit}`;
    };

    const getFileUsageInfo = useCallback(
        (fileUsage: ICustomerSetting[]): FileUsageInfoType => {
            const fileCount: ICustomerSetting = fileUsage.filter((item) => item.key === FILE_USAGE.FILE_COUNT)[0];

            const usedKb: ICustomerSetting = fileUsage.filter((item) => item.key === FILE_USAGE.USED_KB)[0];

            let usedFileSize = undefined;

            if (usedKb.value) {
                usedFileSize = getFormattedFileSize(usedKb.value);
            }

            return {
                fileCount: fileCount.value,
                usedKb: usedFileSize,
                udpated: fileCount.updated
                    ? dateFormat(new Date(fileCount.updated), "dd.MM.yyyy, HH:mm:ss")
                    : undefined
            };
        },
        []
    );

    const { customerFileUsage, filesWithErrorsCount } = props;

    let fileUsageData = undefined;

    if (customerFileUsage && customerFileUsage.length > 0) {
        fileUsageData = getFileUsageInfo(customerFileUsage);
    }

    const hasFilesWithErrors = (filesWithErrorsCount ?? 0) > 0;

    if (!fileUsageData && !hasFilesWithErrors) {
        return <></>;
    }

    let customerLogLink = undefined;

    if (hasFilesWithErrors) {
        customerLogLink = <Link to={"faulty-files"}>{"Ansehen >"}</Link>;
    }

    const fileUsageInfoItems = [
        { infoHeading: "Anzahl Dateien", infoValue: fileUsageData?.fileCount },
        { infoHeading: "Benötigter Speicherplatz", infoValue: fileUsageData?.usedKb },
        { infoHeading: "Aktualisiert am", infoValue: fileUsageData?.udpated },
        { infoHeading: "Dateien mit Fehlern", infoValue: customerLogLink }
    ];

    return <InfoContainer infoItems={fileUsageInfoItems} />;
};

export default CustomerFileUsage;
